module.exports = __webpack_public_path__ + "static/img/KV-bg@2x_2023.94ff64a9.png";